// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-77sxHOss","foot_link":"foot_link-r4fqH1c4","list":"list-YLwxfE5V","link":"link-36KijYOv","copyright":"copyright-3V246xxG"};